var _ = require('underscore');
var $ = require('jquery');
var Labels = EY.Consultation.Labels;
var Marionette = require('marionette');
var Entities = require('Entities');
var Dropdown = require('Dropdown');
var Grid = require('Grid');
var Search = require('RecordSearchTopic');
var Dialog = require('Dialog');
var Validation = require('validation');


var Action = Marionette.View.extend({
    events: {
        'click': 'action'
    },
    tagName: 'td',
    template: '#topicGridAddAction',
    className: 'select-topic',
    ui: {
        data: '#data'
    },
    onRender: function () {
        this.ui.data.text(this.model.get(this.options.column.get("name")));
    },
    action: function () {
        if (this.model.collection.findWhere({ selected: true }))
            this.model.collection.findWhere({ selected: true }).set("selected", false);

        this.model.set("selected", true);

        $('#gridSection').find('td').removeClass("mark");
        this.$el.parent().find("td").addClass("mark");
    }
});

var Topic = Marionette.View.extend({
    tagName: 'th',
    template: '#topicLayout',
    className: 'topic-header',
    regions: {
        type: '#type'
    },
    onRender: function () {
        var options = this.options.column.get("layoutOptions");
        var layout = options.layout;
        var record = options.record;
        var subtypes = this.options.column.get("subtypes");
        var types = options.types;
        var context = options;


        Dropdown.show({
            collection: types.clone(),
            tooltip: true,
            placeholder: function () {
                return Labels.Topic;
            },
            region: this.getRegion('type'),
            onDropdownChanged: function () {
                layout.getRegion('searchSection').currentView.$el.find('#keyword').val("");
                $('#subtype').find('select').prop('selectedIndex', 0);
                $('#subject').find('select').prop('selectedIndex', 0);
            },
            onSelectionChanged: function (type) {
                if (type && type.id) {
                    options.searchedTopics.reset(options.unFilteredTopics.filter(function (row) {
                        return row.get("typeText").toLowerCase().indexOf(type.get('text').toLowerCase()) !== -1;
                    }));

                    $('#gridSection').find('table td').each(function () {
                        if ($(this).text().trim().toLowerCase().indexOf(type.get('text').trim().trim().toLowerCase()) > -1) {
                            $(this).addClass("mark");
                        }
                    });
                }

                subtypes.reset(context.subtypes.clone().filter(function (subtype) {
                    return subtype.id.indexOf(type.id) === 0;
                }));
            }
        });
    }
});
var SubTopic = Marionette.View.extend({
    tagName: 'th',
    template: '#subtopicLayout',
    className: 'topic-header',
    regions: {
        subtype: '#subtype'
    },
    onRender: function () {
        var options = this.options.column.get("layoutOptions");
        var layout = options.layout;
        var types = options.types;
        var subtypes = this.options.column.get("subtypes");
        var subjects = this.options.column.get("subjects");
        var context = options;


        Dropdown.show({
            autoselect: false,
            collection: subtypes,
            tooltip: true,
            parentCollection: types,
            placeholder: function () {
                return Labels.Subtopic1;
            },
            region: this.getRegion('subtype'),
            onDropdownChanged: function () {
                $('#subject').find('select').prop('selectedIndex', 0);
            },
            onSelectionChanged: function (subtype) {
                if (subtype && subtype.id) {
                    options.searchedTopics.reset(options.unFilteredTopics.filter(function (row) {
                        return row.get("typeText").toLowerCase().indexOf( $("#type option:selected").text().trim().toLowerCase()) !== -1
                            && row.get("subTypeText").toLowerCase().indexOf(subtype.get('text').trim().toLowerCase()) !== -1;
                    }));

                    $('#gridSection').find('table td').each(function () {
                        //if ($(this).text().trim().toLowerCase().indexOf( $("#type option:selected").text().trim().toLowerCase()) > -1) {
                        //    $(this).addClass("mark");
                        //}
                        if ($(this).text().trim().toLowerCase().indexOf(subtype.get('text').trim().toLowerCase()) > -1) {
                            $(this).addClass("mark");
                        }
                    });
                }
                subjects.reset(context.subjects.clone().filter(function (subject) {
                    return subject.id.indexOf(subtype.id) === 0;
                }));
            }
        });
    }
});
var Subject = Marionette.View.extend({
    tagName: 'th',
    template: '#subjectLayout',
    className: 'topic-header',
    regions: {
        subject: '#subject'
    },
    onRender: function () {
        var options = this.options.column.get("layoutOptions");
        var layout = options.layout;
        var subtypes = this.options.column.get("subtypes");
        var subjects = this.options.column.get("subjects");

        Dropdown.show({
            autoselect: false,
            collection: subjects,
            parentCollection: subtypes,
            placeholder: function () {
                return Labels.Subtopic2;
            },
            region: this.getRegion('subject'),
            tooltip: true,
            onSelectionChanged: function (subject) {
                if (subject && subject.id) {
                    options.searchedTopics.reset(options.unFilteredTopics.filter(function (row) {
                       
                        return row.get("typeText").toLowerCase().indexOf( $("#type option:selected").text().trim().toLowerCase()) !== -1
                            && row.get("subTypeText").toLowerCase().indexOf( $("#subtype option:selected").text().trim().toLowerCase()) !== -1
                            && row.get("subjectText").toLowerCase().indexOf(subject.get('text').trim().toLowerCase()) !== -1;
                    }));

                    $('#gridSection').find('table td').each(function () {
                        //if ($(this).text().trim().toLowerCase().indexOf( $("#type option:selected").text().trim().toLowerCase()) > -1) {
                        //    $(this).addClass("mark");
                        //}
                        //if ($(this).text().trim().toLowerCase().indexOf( $("#subtype option:selected").text().trim().toLowerCase()) > -1) {
                        //    $(this).addClass("mark");
                        //}
                        if ($(this).text().trim().toLowerCase().indexOf(subject.get('text').trim().toLowerCase()) > -1) {
                            $(this).addClass("mark");
                        }
                    });
                }
            }
        });
    }
});
var columns = function (options) {
    var record = options.record;
    var subjects = new Entities.Classifications();
    var subtypes = new Entities.Classifications();

    return [{ name: 'typeText', label: "Topic", editable: false, cell: Action, record: record, subtypes:subtypes,subjects:subjects,layout: options.layout, sortable: false, headerCell: Topic, layoutOptions: options },
        { name: 'subTypeText', label: "Sub Topic 1", editable: false, cell: Action, record: record, subtypes: subtypes, subjects:subjects,layout: options.layout, sortable: false, headerCell: SubTopic, layoutOptions: options },
        { name: 'subjectText', label: "Sub Topic 2", editable: false, cell: Action, record: record, subtypes: subtypes, subjects: subjects, layout: options.layout, sortable: false, headerCell: Subject, layoutOptions: options }];
};

var View = Marionette.View.extend({
    template: '#recordTopicLayout',
    regions: {
        type: '#type',
        subtype: '#subtype',
        subject: '#subject',
        gridSection: '#gridSection',
        searchSection: '#searchSection'
    },
    initialize: function () {
        Validation.bind(this);
    },
    events: {
        'click #clear': 'clear'
    },
    clear: function () {
        this.options.searchedTopics.reset(this.options.unFilteredTopics.toJSON());
        this.options.types.findWhere({ selected: true }) && this.options.types.findWhere({ selected: true }).set("selected", false);
        $('#type').find('select').prop('selectedIndex', 0);
        this.getRegion('searchSection').currentView.$el.find('#keyword').val("");

    }
});



var classifications = function (options) {
    var layout = options.layout;
    var record = options.record;
    var subjects = new Entities.Classifications();
    var subtypes = new Entities.Classifications();
    var types = options.types;
    var context = options;


    Dropdown.show({
        collection: types.clone(),
        placeholder: function () {
            return Labels.Select;
        },
        region: layout.getRegion('type'),
        onDropdownChanged: function () {
            layout.getRegion('searchSection').currentView.$el.find('#keyword').val("");
            layout.getRegion('subtype').currentView.$el.find('select').prop('selectedIndex', 0);
            layout.getRegion('subject').currentView.$el.find('select').prop('selectedIndex', 0);
        },
        onSelectionChanged: function (type) {
            if (type && type.id) {
                options.searchedTopics.reset(options.unFilteredTopics.filter(function (row) {
                    return row.get("typeText").toLowerCase().indexOf(type.get('text').toLowerCase()) !== -1;
                }));

                $('#gridSection').find('table td').each(function () {
                    if ($(this).text().trim().toLowerCase().indexOf(type.get('text').trim().toLowerCase()) > -1) {
                        $(this).addClass("mark");
                    }
                });
            } 

            subtypes.reset(context.subtypes.clone().filter(function (subtype) {
                return subtype.id.indexOf(type.id) === 0;
            }));
        }
    });
    Dropdown.show({
        autoselect: true,
        collection: subtypes,
        parentCollection: types,
        placeholder: function () {
            return Labels.Select;
        },
        region: layout.getRegion('subtype'),
        onDropdownChanged: function () {
            layout.getRegion('subject').currentView.$el.find('select').prop('selectedIndex', 0);
        },
        onSelectionChanged: function (subtype) {
            if (subtype && subtype.id) {
                options.searchedTopics.reset(options.unFilteredTopics.filter(function (row) {
                    return row.get("typeText").toLowerCase().indexOf(layout.getRegion('type').currentView.$el.find('select').text().trim().toLowerCase()) !== -1
                        || row.get("subTypeText").toLowerCase().indexOf(subtype.get('text').trim().toLowerCase()) !== -1;
                }));

                $('#gridSection').find('table td').each(function () {
                    if ($(this).text().trim().toLowerCase().indexOf(layout.getRegion('type').currentView.$el.find('select').text().trim().toLowerCase()) > -1) {
                        $(this).addClass("mark");
                    }
                    if ($(this).text().trim().toLowerCase().indexOf(subtype.get('text').trim().toLowerCase()) > -1) {
                        $(this).addClass("mark");
                    }
                });
            }
            subjects.reset(context.subjects.clone().filter(function (subject) {
                return subject.id.indexOf(subtype.id) === 0;
            }));
        }
    });
    Dropdown.show({
        autoselect: true,
        collection: subjects,
        parentCollection: subtypes,
        placeholder: function () {
            return Labels.Select;
        },
        region: layout.getRegion('subject'),
        tooltip: true,
        onSelectionChanged: function (subject) {
            if (subject && subject.id) {
                options.searchedTopics.reset(options.unFilteredTopics.filter(function (row) {
                    return row.get("typeText").toLowerCase().indexOf(layout.getRegion('type').currentView.$el.find('select').text().trim().toLowerCase()) !== -1
                        || row.get("subTypeText").toLowerCase().indexOf(layout.getRegion('subtype').currentView.$el.find('select').text().trim().toLowerCase()) !== -1
                        || row.get("subjectText").toLowerCase().indexOf(subject.get('text').trim().toLowerCase()) !== -1;
                }));

                $('#gridSection').find('table td').each(function () {
                    if ($(this).text().trim().toLowerCase().indexOf(layout.getRegion('type').currentView.$el.find('select').text().trim().toLowerCase()) > -1) {
                        $(this).addClass("mark");
                    }
                    if ($(this).text().trim().toLowerCase().indexOf(layout.getRegion('subtype').currentView.$el.find('select').text().trim().toLowerCase()) > -1) {
                        $(this).addClass("mark");
                    }
                    if ($(this).text().trim().toLowerCase().indexOf(subject.get('text').trim().toLowerCase()) > -1) {
                        $(this).addClass("mark");
                    }
                });
            }
        }
    });
};

var configure = function (options) {
    var subjects = new Entities.Classifications();
    var subtypes = new Entities.Classifications();
    var types = new Entities.Classifications();
    var classificationByType = options.classificationCollection.groupBy('type');

    types.reset(classificationByType.Type);
    subtypes.reset(classificationByType.Subtype);
    subjects.reset(classificationByType.Subject);

    types.each(function (type) {
        var filteredSubtypes = subtypes.filter(function (subtype) {
            return subtype.id.indexOf(type.id) === 0;
        });
        _.each(filteredSubtypes, function (filteredSubType) {

            var filteredSubjects = subjects.filter(function (subject) {
                return subject.id.indexOf(filteredSubType.id) === 0;
            });
            _.each(filteredSubjects, function (filteredSubject) {
                options.searchedTopics.add({
                    typeId: type.get("id"),
                    typeText: type.get("text"),
                    subTypeId: filteredSubType.get("id"),
                    subTypeText: filteredSubType.get("text"),
                    subjectId: filteredSubject.get("id"),
                    subjectText: filteredSubject.get("text")
                });
            });

        });

    });

    options.unFilteredTopics.reset(options.searchedTopics.toJSON());
};
module.exports.start = function (options) {
    options.searchedTopics = new Backbone.Collection();
    options.unFilteredTopics = new Backbone.Collection();
    configure(options);
    var validationModel = new Backbone.Model();
    validationModel.validation = _.extend([], {
        topic: function (value) {
            return !options.searchedTopics.any({ selected: true }) ? Labels.AddWarning : ''; 
        }
    });
    var layout = new View(_.extend(options,{model:validationModel}));
    Dialog.show({
        cancelLabel: Labels.Cancel,
        headerLabel: Labels.TopicInformation,
        saveLabel: Labels.Add,
        validate: validationModel,
        view: layout,
        size:"modal-xl"
    }).done(function () {
        var record = options.record;
        var selctedSearchedTopic = options.searchedTopics.findWhere({ selected: true });
        if (selctedSearchedTopic) {
            record.set('typeId', selctedSearchedTopic.get("typeId"));
            record.set('type', selctedSearchedTopic.get("typeText"));

            record.set('subtypeId', selctedSearchedTopic.get("subTypeId"));
            record.set('subtype', selctedSearchedTopic.get("subTypeText"));

            record.set('subjectId', selctedSearchedTopic.get("subjectId"));
            record.set('subject', selctedSearchedTopic.get("subjectText"));
            record.set('topics', selctedSearchedTopic.get("typeText") + "," + selctedSearchedTopic.get("subTypeText") + "," + selctedSearchedTopic.get("subjectText"));
        } else {
            require('Consultation').showToast({ result: "info", text: "No Topics were updated"});
        }
        options.types.findWhere({ selected: true }) && options.types.findWhere({ selected: true }).set("selected", false);
    }).fail(function () {
        options.types.findWhere({ selected: true }) && options.types.findWhere({ selected: true }).set("selected", false);
    });
    Search.show({ types: options.types, subtypes: options.subtypes, subjects: options.subjects,record: options.record,searchedTopics: options.searchedTopics, unFilteredTopics: options.unFilteredTopics, layout:layout,region: layout.getRegion('searchSection') });
    //classifications(_.extend(options, {searchedTopics: options.searchedTopics, unFilteredTopics: options.unFilteredTopics, layout: layout }));
    Grid.show({
        collection: options.searchedTopics,
        columns: columns(_.extend(options, { layout: layout})),
        region: layout.getRegion('gridSection')
    });

   
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordAddTopic.js